<template>
  <div>
    <v-container class="pt-8 px-10">
      <h1 class="display-1 mb-4">Posts</h1>
      <v-row class="px-4" align-center>
        <v-btn
          class="primary mb-4"
          @click="newPost({})"
        >
          <v-icon class="mr-1">mdi-plus</v-icon>New
        </v-btn>
        <v-btn
          class="primary mb-4 ml-4"
          @click="sort.desc = !sort.desc"
        >
          <v-icon class="mr-1">mdi-sort</v-icon>
          {{ sort.desc ? 'Most Recent' : 'Oldest' }}
        </v-btn>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" class="pa-2">
          <FbMemberAutocomplete
            v-model="filter.author"
            label="Filter by author"
            clearable 
            no-random />
        </v-col>
        <v-col cols="12" md="6" lg="4" class="pa-2">
          <v-autocomplete
            v-model="filter.tags"
            :items="tags"
            filled
            chips
            label="Filter by tags"
            multiple
            clearable
            hide-details
            hide-no-data />
        </v-col>
        <v-col cols="12" md="6" lg="4" class="pa-2">
          <v-text-field
            v-model.trim="filter.search"
            filled
            label="Caption search"
            height="68px"
            clearable
            hide-details />
        </v-col>
      </v-row>
      <div class="status-list mx-auto mt-4">
        <FbStatus
          v-for="status in sortedStatuses"
          mode="list"
          :key="status.id"
          :id="status.id"
          :status="status"
          @delete="confirmDeletePost"
          @share="newShare"
          show-options />
      </div>
    </v-container>
    <v-dialog v-model="deleteDialog.show" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Post</v-card-title>
        <v-card-text>
          Are you sure you want to delete this post?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog.show = false">Cancel</v-btn>
          <v-btn color="error" text @click="deletePost">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FbStatus from '../components/FbStatus'
import FbMemberAutocomplete from '../components/FbMemberAutocomplete'

import { randomId, prefGet, prefSet } from '../utils'

const KEY_SORT = 'FbStatusList_sort'
const KEY_FILTER = 'FbStatusList_filter'

export default {
  name: 'FbStatusList',
  injectModels: ['Store'],
  components: {
    FbStatus,
    FbMemberAutocomplete
  },
  data() {
    return {
      statuses: {},
      deleteDialog: {
        show: false,
        id: ''
      },
      sort: {
        by: 'timestamp',
        desc: true
      },
      filter: {
        author: '',
        tags: [],
        search: ''
      }
    }
  },
  created() {
    if (this.Store.fb.posts == null)
      this.Store.fb.posts = {}
    this.statuses = this.Store.fb.posts
    this.sort = prefGet(KEY_SORT, this.sort)
    this.filter = prefGet(KEY_FILTER, this.filter)
  },
  beforeDestroy() {
    prefSet(KEY_SORT, this.sort)
    prefSet(KEY_FILTER, this.filter)
  },
  computed: {
    tags() {
      const tags = []
      for (let id in this.statuses) {
        const status = this.statuses[id]
        tags.push(...(status._tags || []))
      }
      return tags.sort()
    },
    sortedStatuses() {
      const statuses = []

      for (let id in this.statuses) {
        const status = this.statuses[id]
        const { 
          author: sAuthor = '', 
          _tags: sTags = [], 
          caption: sCaption = ''
        } = status
        const { author, tags, search } = this.filter
        
        if (
          (!author || sAuthor === author) &&
          (!tags.length || tags.every(t => sTags.includes(t))) &&
          (!search || sCaption.toLowerCase().includes(search.toLowerCase()))
        ) {
          statuses.push({ id, ...status })
        }
      }

      return statuses.sort((a, b) => {
        const { by, desc } = this.sort
        const s = a[by] > b[by]
        return desc ? !s : s
      })
    }
  },
  methods: {
    newPost(init) {
      const id = randomId()
      this.$set(this.statuses, id, init)
      this.$router.push({ path: id, append: true })
    },
    newShare(id) {
      let share = this.statuses[id]
      if (share == null)
        return
      // Share original status
      if (share.content && share.content.type === 'share')
        id = share.content.id
        
      this.newPost({
        timestamp: share.timestamp,
        content: { type: 'share', id }
      })
    },
    confirmDeletePost(id) {
      this.deleteDialog.show = true
      this.deleteDialog.id = id
    },
    deletePost() {
      this.deleteDialog.show = false
      this.$delete(this.statuses, this.deleteDialog.id)
    }
  }
}
</script>

<style scoped>
.status-list > * {
  margin: 0 auto 16px auto;
}
</style>
